/**
 * Centralized API configuration
 * This file manages all API base URL configuration for the application
 */
// Get the API base URL - production-first approach
// Always use Azure backend unless explicitly running on localhost
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
// Force production backend for Azure Static Web Apps
const isAzureStaticWebApp = window.location.hostname.includes('azurestaticapps.net');
export const API_BASE_URL = isLocalhost
    ? 'http://localhost:3000' // Local development
    : 'https://ygp-backend-webapp.azurewebsites.net'; // Production (Azure Static Web Apps)
// Debug logging (remove in production)
console.log('API Config:', {
    hostname: window.location.hostname,
    isLocalhost,
    isAzureStaticWebApp,
    API_BASE_URL,
    fullURL: window.location.href
});
// Export a configured axios instance for consistent usage
import axios from 'axios';
export const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000, // 10 second timeout
    headers: {
        'Content-Type': 'application/json',
    },
});
// Add request interceptor to automatically add auth token
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
// Add response interceptor for error handling
apiClient.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 401) {
        // Handle unauthorized access
        localStorage.removeItem('auth_token');
        window.location.href = '/login';
    }
    return Promise.reject(error);
});
export default apiClient;
